import { UnitType } from '@exodus/currency'

const name = 'ark'
const displayName = 'ARK'
const ticker = 'ARK'
const displayTicker = 'ARK'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#C9282C'
const gradientColors = ['#C9282C', '#C92854']
const gradientCoords = { x1: '102%', y1: '101%', x2: '0%', y2: '0%' }
const chainBadgeColors = gradientColors

const units = {
  ARKtoshis: 0,
  ARK: 8,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://explorer.ark.io/wallets/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://explorer.ark.io/transaction/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Ark links blockchain projects together in a bridge system. Ark uses SmartBridges to communicate between blockchains allowing developers to access a wider range of features than focusing on a single blockchain platform.',
  reddit: 'https://www.reddit.com/r/ArkEcosystem/',
  twitter: 'https://twitter.com/ArkEcosystem',
  website: 'https://ark.io/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
